import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const AlarmListService = {
    sources: async () => axios.get(`${API_URL}/alarm_list/get/sources`).then(({data}) => data.map(d => ({value: d.id, label: d.text}))).catch((err) => { throw err })
};

export default AlarmListService;